import './index.scss';
import dayjs from 'dayjs';
import React, { useState, Fragment } from 'react';
import { Drawer, Iconfont, COMPOENT_THEME } from '@umu/umu-design';
import { defaultDateFormat, defaultMaxWidth, defaultPlaceholder } from './dataFlow';
import { DateRange, IMobileBasicInfo, PlacementTypes, DateMode } from './interface';
import { PickerPanel } from './components';

interface IProps extends IMobileBasicInfo {
    zIndex?: number;
    justifyContent?: 'space-around' | 'space-between' | 'center' | 'flex-start' | 'flex-end' | 'space-evenly';
    isHideIconDate?: boolean;
    isMultiple?: boolean; // 是否多选
    maxWidth?: string | number;
    placement?: PlacementTypes;
    isShowMask?: boolean;
    destroyOnClose?: boolean;
    prefixElement?: React.ReactNode | string;
}

const MobilePicker = (props: IProps) => {
    const {
        preCls = 'umu-mobile-picker',
        dateFormat = defaultDateFormat,
        maxWidth = defaultMaxWidth,
        defaultValue,
        isHideIconDate = false,
        theme = COMPOENT_THEME.GOLDEN,
        zIndex = 4000 /* 默认吸底fixed布局层级为3000*/,
        isShowMask = true,
        prefixElement = '',
        destroyOnClose = false,
        clearBtn,
        mode = DateMode.multiple,
        justifyContent = 'space-around',
        placement = PlacementTypes.bottom,
        placeholder = defaultPlaceholder,
        disabledDate,
    } = props;
    const [visible, setVisible] = useState(false);
    const isSignal = mode === DateMode.signal;
    const onOpenChange = () => {
        setVisible(!visible);
    };
    const isHasDate = defaultValue?.[0] && defaultValue?.[1];
    const onDrawerClose = () => {
        setVisible(false);
    };
    const onPickerChange = (newValue?: DateRange) => {
        onDrawerClose();
        props.onChange && props.onChange(newValue);
    };
    // mode
    const renderSignalContent = () => {
        const signalLabel = defaultValue?.[0] ? dayjs(defaultValue?.[0]).format(dateFormat) : placeholder;
        return (
            <div className={`${preCls}-signal-date`}>
                <div className={`${preCls}-signal-date-prefix`}>{prefixElement}</div>
                <div className={`${preCls}-signal-date-value`}>{signalLabel}</div>
            </div>
        );
    };
    const renderMultipleContent = () => {
        return (
            <Fragment>
                <div className={`${preCls}-date`}>
                    {!isHideIconDate && <div className="icon-date" />}
                    <div className={`${preCls}-date-info justify-content-${justifyContent}`}>
                        <div className={`${preCls}-date-info-label ${isHasDate ? '' : 'empty-date'}`}>
                            {defaultValue?.[0] ? dayjs(defaultValue?.[0]).format(dateFormat) : placeholder[0]}
                        </div>
                        <div className={`${preCls}-date-info-split`}>-</div>
                        <div className={`${preCls}-date-info-label ${isHasDate ? '' : 'empty-date'}`}>
                            {defaultValue?.[1] ? dayjs(defaultValue?.[1]).format(dateFormat) : placeholder[1]}
                        </div>
                    </div>
                </div>
                <Iconfont type="DropDown" className={`icon-select-arrow ${visible ? 'arrow-down' : 'arrow-up'}`} />
            </Fragment>
        );
    };
    return (
        <div className={`${preCls} ${mode}`} onClick={onOpenChange}>
            {isSignal ? renderSignalContent() : renderMultipleContent()}
            <Drawer
                visible={visible}
                closable={false}
                destroyOnClose={destroyOnClose}
                mask={isShowMask}
                zIndex={zIndex}
                style={{ maxWidth, zIndex: 4000 }}
                contentWrapperStyle={{ height: 'unset' }}
                maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
                className={`${preCls}-drawer`}
                placement={placement}
                onClose={onDrawerClose}
            >
                <PickerPanel
                    preCls={`${preCls}-panel`}
                    placeholder={placeholder}
                    dateFormat={dateFormat}
                    theme={theme}
                    mode={mode}
                    clearBtn={clearBtn}
                    defaultValue={defaultValue}
                    disabledDate={disabledDate}
                    onChange={onPickerChange}
                    onClose={onDrawerClose}
                />
            </Drawer>
        </div>
    );
};

export { MobilePicker };
